import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import FlairIcon from '../../../../../atomic/atoms/FlairIcon';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';

type Props = {
  filter: string;
  onFilterChange: (value: string) => void;
};

// Filter-by-employee-name control, shown above the items table inside its card.
export const CompensationReviewToolbar: React.FC<
  React.PropsWithChildren<Props>
> = ({ filter, onFilterChange }) => {
  const t = useNamespacedTranslation('compensationReviews.toolbar');

  return (
    <div className="d-flex flex-wrap align-items-end mb-3">
      <InputGroup className="w-auto">
        <InputGroup.Text>
          <FlairIcon icon="search-filled" size="sm" />
        </InputGroup.Text>
        <Form.Control
          type="search"
          placeholder={t('filterPlaceholder')}
          value={filter}
          aria-label={t('filterPlaceholder')}
          onChange={(event) => onFilterChange(event.target.value)}
        />
      </InputGroup>
    </div>
  );
};
